const useOsSystemColors = () => {
  const osColorMapping = {
    ios: "#A87BCC",
    android: "#9FCC7B",
    win64: "#064CC4",
    macos: "#3b82f6",
    linux: "#06b6d4",
    switch: "#F74251",
  };
  return { osColorMapping };
};

export default useOsSystemColors;
